export default "__VITE_ASSET__DzOSYq8G__"